import UserImage from "components/commons/UserImage"
import { selectCurrentUserGuid } from "features/auth/authSlice"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import SafetyMapDialog from "../SafetyMapDialog"
import getSafetyCardColor, { getSafetyIcon } from "features/safety/SafetyUtils"
import { OverlayPanel } from "primereact/overlaypanel"
import { useRef } from "react"

const SafetyCard = ({
    alarm,
    onAction = (alarmGuid, action) => { },
    onProgress = (alarmGuid, action) => { }
}) => {

    const [t] = useTranslation(["global", "safety"])

    const userGuid = useSelector(selectCurrentUserGuid)


    function getCardColor() {
        return getSafetyCardColor(alarm)
    }


    function getIcon() {
        return getSafetyIcon(alarm)
    }

    const handleAction = (action) => {
        onAction(alarm.user.guid, action)
    }

    let warnings = []

    if (alarm.isVoiceCapable == false) {
        warnings.push(<small><i className="fa-solid fa-phone-slash"></i> {t("safety:label.no_telephony_warning")}</small>)
    }

    if (alarm.isGpsCapable == false) {
        warnings.push(<small><i className="fa-solid fa-crosshairs"></i> {t("safety:label.no_gps_warning")}</small>) 
    }

    const op = useRef(null);

    return (
        <div className="col">
            <div className={`card ${getCardColor()} text-white`}>
                <div className="card-header">
                    <div className="row d-flex justify-content-between">
                        <div className="col-auto">
                            {alarm.status == "IN_PROGRESS" && <i className="fa-solid fa-spinner fa-spin fa-spin-reverse"></i>}
                            {alarm.status == "OPEN" && "🚨"}
                            {alarm.status == "CLOSED" && "✔️"}

                            <span className="ms-1">{t(`safety:entity.alarm.status.${alarm.status}`)}</span>
                        </div>
                        <div className="col-auto">
                            {warnings.length > 0 &&
                                // <span style={{ cursor: "pointer" }}
                                //     title={JSON.stringify(warnings)}> {warnings.length}⚠️</span>
                                <>
                                    <button className="btn btn-sm text-white" onClick={(e) => op.current.toggle(e)} >{warnings.length} ⚠️</button>
                                    <OverlayPanel ref={op}>

                                        {warnings.map((warning) => (
                                            <li>{warning}</li>
                                        ))}

                                    </OverlayPanel>
                                </>
                            }


                        </div>
                        <div className="col-auto">
                            {new Date(alarm.epochTime * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}
                        </div>

                    </div>
                </div>
                <div className="card-body bg-black bg-opacity-25 text-center">
                    <div className="row">
                        <div className="col">

                            <h5>{getIcon()} {t(`safety:entity.alarm.type.${alarm.type}`)}</h5>
                            <UserImage guid={alarm.user.guid} size={36} /> <span className="ps-2">{alarm.user.displayName}</span>
                        </div>
                        {
                            alarm.position &&
                            <div className="col-auto">
                                <SafetyMapDialog focusAlarm={alarm} />
                            </div>

                        }
                    </div>
                </div>
                <div className="card-footer">
                    {
                        (alarm.status == "OPEN" || (alarm.status == "IN_PROGRESS" && alarm.progress.at(-1).operator.guid == userGuid)) ?
                            <>
                                {
                                    alarm.status == "OPEN" &&
                                    <div className="text-center">
                                        <button className="btn btn-danger mx-2" onClick={() => onProgress(alarm.guid, "IN_PROGRESS")} >
                                            <i className="fa-solid fa-hands-clapping fa-beat"></i> {t(`safety:entity.alarm.actions.take_in_charge`)}
                                        </button>
                                    </div>

                                }
                                {
                                    alarm.status == "IN_PROGRESS" && alarm.progress.at(-1).operator.guid == userGuid &&
                                    <div className="row d-flex justify-content-between">
                                        <div className="col-auto">
                                            <button className="btn btn-dark disabled" onClick={() => handleAction('LOCALIZE')} >
                                                <i className="fa-solid fa-location-crosshairs "></i>
                                            </button>

                                            {
                                                <button className={`btn btn-dark mx-2 text-success ${alarm.isVoiceCapable ? null : "disabled"}`} onClick={() => handleAction('CALL')} >
                                                    <i className="fa-solid fa-phone "></i>
                                                </button>
                                            }

                                        </div>
                                        <div className="col-auto">
                                            <button className="btn btn-primary mx-2" onClick={() => onProgress(alarm.guid, "CLOSED")} >
                                                <i className="fa-solid fa-circle-check"></i>  {t(`safety:entity.alarm.actions.mark_as_closed`)}
                                            </button>
                                        </div>
                                    </div>

                                }
                            </>

                            :
                            <div className="row d-flex justify-content-between">
                                <small className="text-muted col-auto">
                                    {
                                        t("safety:entity.alarm.props_label.status_by",
                                            {
                                                last_status: t(`safety:entity.alarm.status.${alarm.status}`),
                                                agent: alarm.progress.at(-1).operator.displayName
                                            }
                                        )
                                    }
                                </small>
                                <small className="text-muted col-auto">
                                    {alarm.handledDuration && <><i className="fa-solid fa-stopwatch"></i> {alarm.handledDuration}</>}
                                </small>
                            </div>
                    }
                </div>
            </div>
        </div >

    )
}

export default SafetyCard